import {
    Card,
    CardLayoutType, ContentBlock, ContentLoader,
    FlexAlign,
    FlexGap,
    FlexJustify,
    StackHorizontal,
    StackVertical
} from "@twigsby/frontend-framework";
import {FormatLocaleDate} from "@twigsby/helpers";
import React, {useEffect} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {SettingsActionType} from "../../../Components/Settings/SettingsTypes";
import UserAction from "../../../Components/Settings/Controls/UserAction";
import { useUserPersonalDetails } from "@twigsby/client-data";
import {useForm, FormProvider } from "@twigsby/frontend-framework/lib/ReactHookForm";
import {useSite} from "../../../Providers/SiteInterfaceProvider";

type UserPersonalDetailsType = {
    name: string,
    clientId: number,
    clientIdNo: string,
    userActions: Array<SettingsActionType>;
    manualActions: Array<SettingsActionType>;
}

const PersonalDetails = () => {
    const { t } = useTranslation();
    const { currentLocale, updatePageMeta } = useSite();
    const formMethods = useForm();

    const {
        status,
        data,
        error,
    } : {
        status: any,
        data: any | UserPersonalDetailsType,
        error: any,
        isFetching: any
    } = useUserPersonalDetails();

    useEffect(() => {
        updatePageMeta({
            title: t(`settings.sections.${"Personal Details"}`)
        });
    }, [currentLocale]);

    return (
        <>
            <StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass={'mb-md'}>
                <h2 className={'mb-0'}>{t(`settings.sections.${"Personal Details"}`)}</h2>
            </StackHorizontal>

            <FormProvider {...formMethods}>
                <StackVertical gap={FlexGap.ExtraLarge}>
                    <div>
                        <Card headerOptions={{ title: t('labels.general')}} type={CardLayoutType.SlimHeader} emptyBody={true}>
                            {status === "loading" ? (
                                <ContentLoader childHeight={'6em'} childCount={4} />
                            ) : status === "error" ? (
                                <ContentBlock error={true} title={error.name} content={error.message} />
                            ) : (
                                <>
                                    {data.manualActions.map((item: SettingsActionType, index: number) =>
                                        <div className={'user-action'} key={`preferencesManualAction${index}`}>
                                            <div className={'fade'}>{item.label}</div>
                                            <div>{item.label === 'DOB' ? FormatLocaleDate(item.value) : item.value}</div>
                                        </div>
                                    )}
                                </>
                            )}
                        </Card>
                    </div>

                    <div>
                        <Card headerOptions={{ title: t('settings.sections.contactDetails')}}
                              type={CardLayoutType.SlimHeader} emptyBody={true}>
                            {status === "loading" ? (
                                <ContentLoader childHeight={'6em'} childCount={4} />
                            ) : status === "error" ? (
                                <ContentBlock error={true} title={error.name} content={error.message} />
                            ) : (
                                <>
                                    {data.userActions.map((item: SettingsActionType, index: number) =>
                                        <UserAction {...item} key={`preferencesUserAction${index}`} />
                                    )}
                                </>
                            )}
                        </Card>
                    </div>
                </StackVertical>

            </FormProvider>
        </>
    )
}

export default PersonalDetails
